import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        userInfo: {},
        token: '',
        isShowLoading: false, // 全局 loading
        msgPoint: 0,
        msgPoints: 0,
        msgTouSu: 0,
        msgAppraise: 0,
        // 左侧菜单栏数据
        menuItems: [
            {
                name: 'Home', // 要跳转的路由名称 不是路径
                size: 18, // icon大小
                type: 'ios-egg-outline', // icon类型
                text: '数据看板-总', // 点击侧边栏跳到一个单独的路由页面，需要提前在 router.js 定义
            },{
                name: 'Home_b', // 要跳转的路由名称 不是路径
                size: 18, // icon大小
                type: 'ios-egg-outline', // icon类型
                text: '数据看板-小区', // 点击侧边栏跳到一个单独的路由页面，需要提前在 router.js 定义
            },
            {
                text: '系统管理',
                type: 'ios-paper',
                children: [
                    {
                        type: 'ios-grid',
                        name: 'userList',
                        text: '用户管理',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    },
                    {
                        type: 'ios-grid',
                        name: 'menuList',
                        text: '菜单管理',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    },
                    {
                        type: 'ios-grid',
                        name: 'characterList',
                        text: '角色管理',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    },
                    {
                        type: 'ios-grid',
                        name: 'tenant',
                        text: '租户管理',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }
                ],
            }, {
                text: '小区管理',
                type: 'ios-paper',
                children: [
                    {
                        type: 'ios-grid',
                        name: 'parkList',
                        text: '小区管理',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: false,
                    },{
                        type: 'ios-grid',
                        name: 'parkType',
                        text: '小区类型',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: false,
                    }
                ],
            }, {
                text: '用户管理',
                type: 'ios-paper',
                children: [
                    {
                        type: 'ios-grid',
                        name: 'personnelClass',
                        text: '物业人员分类',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'personList',
                        text: '用户列表',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    },
                    {
                        type: 'ios-grid',
                        name: 'vehicle',
                        text: '车位管理',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'userExamine',
                        text: '用户审核管理',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    },,
                    {
                        type: 'ios-grid',
                        name: 'personnel',
                        text: '物业人员',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    },
                ],
            }, {
                text: '房屋管理',
                type: 'ios-paper',
                children: [
                    {
                        type: 'ios-grid',
                        name: 'house',
                        text: '楼栋列表',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'unit',
                        text: '单元列表',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'floor',
                        text: '楼层列表',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'room',
                        text: '房间列表',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    },
                ],
            }, {
                text: 'banner管理',
                type: 'ios-paper',
                children: [
                    {
                        type: 'ios-grid',
                        name: 'banner',
                        text: 'banner管理',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    },
                ],
            }, {
                text: '活动管理',
                type: 'ios-paper',
                children: [
                    {
                        type: 'ios-grid',
                        name: 'voteList',
                        text: '投票管理',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'questionnaire',
                        text: '问卷调查',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'notice',
                        text: '公告管理',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'activity',
                        text: '活动管理',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }
                ],
            }, {
                text: '访客管理',
                type: 'ios-paper',
                children: [
                    {
                        type: 'ios-grid',
                        name: 'visitor',
                        text: '访客列表',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'accessControl',
                        text: '访客登记',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    },
                ],
            }, {
                text: '缴费管理',
                type: 'ios-paper',
                children: [
                    {
                        type: 'ios-grid',
                        name: 'payRecordClass',
                        text: '缴费类型',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'payRecordList',
                        text: '缴费列表',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'payRecordNoList',
                        text: '未缴费列表',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'templateList',
                        text: '缴费模板管理',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'templateTypeList',
                        text: '缴费模板类型',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'dailyReport',
                        text: '资金日报表',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'monthlyReport',
                        text: '资金月报表',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'provisionalBill',
                        text: '临时账单',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'billReview',
                        text: '账单审核',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }
                ],
            }, {
                text: '投诉管理',
                type: 'ios-paper',
                children: [{
                    type: 'ios-grid',
                    name: 'complaint',
                    text: '投诉列表',
                    // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                    // hidden: true,
                }, {
                    type: 'ios-grid',
                    name: 'complaintClass',
                    text: '投诉分类',
                    // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                    // hidden: true,
                }
                ],
            }, {
                text: '评价管理',
                type: 'ios-paper',
                children: [
                    {
                        type: 'ios-grid',
                        name: 'evaluate',
                        text: '评价列表',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }
                ],
            }, {
                text: '报事报修',
                type: 'ios-paper',
                children: [
                    {
                        type: 'ios-grid',
                        name: 'report',
                        text: '报修列表',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    },
                    {
                        type: 'ios-grid',
                        name: 'warrantyClass',
                        text: '报修分类',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'price',
                        text: '维修价目列表',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'addWarranty',
                        text: '添加报修',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'unhandled',
                        text: '未处理订单',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'distributed',
                        text: '已分发订单',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'accepted',
                        text: '已受理订单',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'completed',
                        text: '已完成订单',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'rejected',
                        text: '已拒绝订单',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'canceled',
                        text: '已取消订单',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'evaluated',
                        text: '已评价订单',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'allOrder',
                        text: '全部订单',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }
                ],
            }, {
                text: '报事管理',
                type: 'ios-paper',
                children: [
                    {
                        type: 'ios-grid',
                        name: 'matterClass',
                        text: '报事分类',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'addMatter',
                        text: '添加报事',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'Munhandled',
                        text: '未处理订单',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'Mdistributed',
                        text: '已分发订单',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'Maccepted',
                        text: '已受理订单',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'Mcompleted',
                        text: '已完成订单',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'Mrejected',
                        text: '已拒绝订单',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'Mcanceled',
                        text: '已取消订单',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'Mevaluated',
                        text: '已评价订单',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    },
                ],
            }, {
                text: '消息管理',
                type: 'ios-paper',
                children: [
                    {
                        type: 'ios-grid',
                        name: 'newsList',
                        text: '消息管理',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    },
                ],
            }, {
                text: '单页面管理',
                name: 'singlePage',
                type: 'ios-paper',
            }, {
                text: '运维管理',
                type: 'ios-paper',
                children: [
                    {
                        type: 'ios-grid',
                        name: 'navigationList',
                        text: '导航管理',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    },
                    {
                        type: 'ios-grid',
                        name: 'lostArticle',
                        text: '失物招领',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'field',
                        text: '场地预约',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'community',
                        text: '社区服务',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'oldCare',
                        text: '老人关怀',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'doorTodoor',
                        text: '到户服务',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'volunteer',
                        text: '志愿者招募',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'substitution',
                        text: '置换平台',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    },
                ],
            }, {
                text: '扫码巡更',
                type: 'ios-paper',
                children: [
                    {
                        type: 'ios-grid',
                        name: 'nightPatrolClass',
                        text: '巡更点管理',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'nightPatrolList',
                        text: '巡更列表',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'nightPatrolRecord',
                        text: '巡更记录',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }
                ],
            }, {
                text: '浙里办管理',
                type: 'ios-paper',
                children: [
                    {
                        type: 'ios-grid',
                        name: 'zlbOrderWork',
                        text: '工单管理',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'zlbProposal',
                        text: '建议咨询管理',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'zlbVisitorList',
                        text: '访客列表',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    },
                ],
            }, {
                text: '养老食堂',
                type: 'ios-paper',
                children: [
                    {
                        type: 'ios-grid',
                        name: 'canteenClass',
                        text: '分类列表',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'canteenList',
                        text: '商品列表',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'canteenOrder',
                        text: '订单列表',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    },
                ],
            }, {
                text: '置换平台',
                type: 'ios-paper',
                children: [
                    {
                        type: 'ios-grid',
                        name: 'substitutionClass',
                        text: '分类列表',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'substitutionExamine',
                        text: '审核列表',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }
                ],
            }, {
                text: '派单管理',
                type: 'ios-paper',
                children: [
                    {
                        type: 'ios-grid',
                        name: 'distribute',
                        text: '工单派单',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'distributeClass',
                        text: '派单类型',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'distributeRecord',
                        text: '派单记录',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }
                ],
            }, {
                text: '设备运维',
                type: 'ios-paper',
                children: [
                    {
                        type: 'ios-grid',
                        name: 'thingYard',
                        text: '设备列表',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'thingClass',
                        text: '分类列表',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }
                ],
            }, {
                text: '积分商城',
                type: 'ios-paper',
                children: [
                    {
                        type: 'ios-grid',
                        name: 'integralShop',
                        text: '兑换商城商品列表',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, {
                        type: 'ios-grid',
                        name: 'shopOrder',
                        text: '兑换列表',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }
                ],
            }, {
                text: '活动发起管理',
                type: 'ios-paper',
                children: [
                    {
                        type: 'ios-grid',
                        name: 'proposal',
                        text: '活动提案',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, 
                    {
                        type: 'ios-grid',
                        name: 'proposalType',
                        text: '主题类型列表',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    },
                    {
                        type: 'ios-grid',
                        name: 'discuss',
                        text: '共议发起',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }
                ],
            }, {
                text: '缴费管理',
                type: 'ios-paper',
                children: [
                    {
                        type: 'ios-grid',
                        name: 'record',
                        text: '已缴费列表',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    }, 
                    {
                        type: 'ios-grid',
                        name: 'recordNo',
                        text: '未缴费列表',
                        // hidden 属性 隐藏此菜单 可以通过在地址栏上输入对应的 URL 来显示页面
                        // hidden: true,
                    },
                ],
            }
        ],
    },
    mutations: {
        setMenus(state, items) {
            state.menuItems = [...items]
        },
        setToken(state, token) {
            state.token = token;
        },
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo;
        },
        setLoading(state, isShowLoading) {
            state.isShowLoading = isShowLoading
        },
        setMsgPoint(state, msgPoint) {
            state.msgPoint = msgPoint
        },
        setMsgPoints(state, msgPoints) {
            state.msgPoints = msgPoints
        },
        setMsgTouSu(state, msgTouSu) {
            state.msgTouSu = msgTouSu
        },
        setMsgAppraise(state, msgAppraise) {
            state.msgAppraise = msgAppraise
        }
    },
})

export default store